import { RouteObject } from "react-router";
import { MatchesRoute } from "./matches/matches-route";

export const businessCentralRoutes: RouteObject[] = [
  {
    path: "matches",
    element: <MatchesRoute />,
  },
];
